'use client'

import { Icon } from './icon'

interface StepperProps {
  label: string
  value: number
  onChange: (v: number) => void
  min?: number
  max?: number
  suffix?: string
}

/** Stepper [-] valor [+] para inteiros pequenos (horas, dias). */
export function Stepper({ label, value, onChange, min = 1, max = 30, suffix }: StepperProps) {
  return (
    <div className="mb-4">
      <div className="mb-2 text-sm text-ink">{label}</div>
      <div className="flex h-[46px] items-center overflow-hidden rounded-[10px] border border-line bg-surface">
        <button
          type="button"
          aria-label="Diminuir"
          onClick={() => onChange(Math.max(min, value - 1))}
          className="flex h-full w-[46px] items-center justify-center border-r border-line-soft bg-background text-ink-mute hover:bg-brand-tint hover:text-brand"
        >
          <Icon name="minus" size={16} />
        </button>
        <div className="flex-1 text-center font-mono text-[17px] text-ink tabular-nums">
          {value}
          {suffix && <span className="ml-1 text-xs text-ink-faint">{suffix}</span>}
        </div>
        <button
          type="button"
          aria-label="Aumentar"
          onClick={() => onChange(Math.min(max, value + 1))}
          className="flex h-full w-[46px] items-center justify-center border-l border-line-soft bg-background text-ink-mute hover:bg-brand-tint hover:text-brand"
        >
          <Icon name="plus" size={16} />
        </button>
      </div>
    </div>
  )
}
